import { Button, Form, Input, InputNumber, Modal, Select } from "antd";
import { FormattedMessage } from "react-intl";
import { RefundMethod } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import MainCreationForm from "components/forms/MainCreationForm";

import { RefundModalProps } from "./types";

const RefundModal: React.FC<RefundModalProps> = ({
  onFinish,
  initialValues,
  fields,
  loading,
  ...modalProps
}) => (
  <Modal
    title={<FormattedMessage defaultMessage="Issue a Refund" />}
    footer={null}
    {...modalProps}
  >
    <MainCreationForm {...{ onFinish, initialValues, fields }}>
      <Form.Item
        name={["input", "amount"]}
        label={<FormattedMessage defaultMessage="Refund Amount" />}
        required
      >
        <InputNumber precision={2} />
      </Form.Item>
      <Form.Item
        name={["input", "reason"]}
        label={<FormattedMessage defaultMessage="Staff Reason" />}
        required
      >
        <Input.TextArea />
      </Form.Item>
      <Form.Item
        name={["input", "method"]}
        label={<FormattedMessage defaultMessage="Form of Refund" />}
        required
      >
        <Select>
          {Object.values(RefundMethod).map((value) => (
            <Select.Option key={value} {...{ value }}>
              {value}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" {...{ loading }}>
          <FormattedMessage defaultMessage="Submit" />
        </Button>
      </Form.Item>
    </MainCreationForm>
  </Modal>
);

export default RefundModal;
